import {
  LOOM_STARTER_FREE_PLAN_KEY,
  SUBSCRIPTION_STATUS_ACTIVE,
  SUBSCRIPTION_STATUS_CANCELED,
  SUBSCRIPTION_STATUS_INCOMPLETE,
  SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED,
  SUBSCRIPTION_STATUS_PAST_DUE,
  SUBSCRIPTION_STATUS_TRIALING,
} from 'constants/billingAndPayments';

import { secondsToMilliseconds } from '../../../../shared/utilities/time';

export const isTrialing = (billingDetails = {}) => {
  const { plan } = billingDetails;

  if (!plan) {
    return false;
  }

  return plan.current_status === SUBSCRIPTION_STATUS_TRIALING;
};

export const isActive = (billingDetails = {}) => {
  const { plan } = billingDetails;

  if (!plan) {
    return false;
  }

  return plan.current_status === SUBSCRIPTION_STATUS_ACTIVE;
};

export const isPastDue = (billingDetails = {}) => {
  const { plan } = billingDetails;

  if (!plan) {
    return false;
  }

  return plan.current_status === SUBSCRIPTION_STATUS_PAST_DUE;
};

export const isCancelled = (billingDetails = {}) => {
  const { plan } = billingDetails;

  if (!plan) {
    return false;
  }

  return plan.current_status === SUBSCRIPTION_STATUS_CANCELED;
};

export const paymentFailed = (billingDetails = {}) => {
  const { plan } = billingDetails;

  if (!plan) {
    return false;
  }

  const currentStatus = plan.current_status;

  return (
    currentStatus === SUBSCRIPTION_STATUS_INCOMPLETE ||
    currentStatus === SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED
  );
};

export const cancelAtPeriodEnd = (billingDetails = {}) => {
  const { billing_period } = billingDetails;

  if (!billing_period) {
    return false;
  }

  return billing_period.cancel_at_period_end;
};

export const willBeActive = (billingDetails = {}) => {
  return isTrialing(billingDetails) && !cancelAtPeriodEnd(billingDetails);
};

export const isPureTrial = (billingDetails = {}) => {
  return isTrialing(billingDetails) && cancelAtPeriodEnd(billingDetails);
};

export const getPlanScheduleChange = (billingDetails = {}) => {
  const { plan } = billingDetails;

  const schedulePhases = plan?.schedule?.phases;

  if (!schedulePhases) {
    return null;
  }

  return schedulePhases.find(phase => {
    const phaseStart = secondsToMilliseconds(phase.start_date);

    return phaseStart > Date.now();
  });
};

export const isPlanDowngradePlanned = (billingDetails = {}) => {
  const { hasPaymentSource, billing_period } = billingDetails;
  const cancelAtPeriodEnd = billing_period?.cancel_at_period_end;

  const scheduledPlanChange = getPlanScheduleChange(billingDetails);
  const scheduledPlan = scheduledPlanChange?.plans?.[0];

  return (
    scheduledPlan?.plan ||
    (cancelAtPeriodEnd && hasPaymentSource && LOOM_STARTER_FREE_PLAN_KEY)
  );
};
